import { DynamicElementMixin } from "%/dynamic-components/render-engine/mixins/production/dynamic-element-mixin";
import { $axios } from "@bloglovin/vue-framework";
import { usePublishedStoryFeedStore } from "SmartFeed/stores/feed/published-story-feed-store";
import { useCommentedStoryFeedStore } from "SmartFeed/stores/feed/commented-story-feed-store";
import { useLovedStoryFeedStore } from "SmartFeed/stores/feed/loved-story-feed-store";
import { useVotedStoryFeedStore } from "SmartFeed/stores/feed/voted-story-feed-store";
import { useGeneralStore } from "%/stores/general-store";
export const UserProfilePageElementMixin = {
  extends: DynamicElementMixin,
  created() {
    usePublishedStoryFeedStore().metadata.userId = this.entityId;
    useCommentedStoryFeedStore().metadata.userId = this.entityId;
    useVotedStoryFeedStore().metadata.userId = this.entityId;
    useLovedStoryFeedStore().metadata.userId = this.entityId;
  },
  data() {
    return {
      defaultFallbackSrc: "https://inspirationprod.blob.core.windows.net/inspiration-cdn/images/avatar-default.png",
    };
  },
  methods: {
    getExampleEntity() {
      return {
        "userId": this.entityId,
        "username": "John Smith",
        "bio": "I am a creator on inspiration.co",
        "avatarUrl": "https://inspirationprod.blob.core.windows.net/inspiration-cdn/images/john-smith-profile-picture.webp",
        "splashImageUrl": "https://inspirationprod.blob.core.windows.net/inspiration-cdn/images/publication/publication-blog.webp",
        "dateCreated": Date.now() / 1000,
        "dateUpdated": Date.now() / 1000,
        "status": "active",
        "primaryOrgId": 0,
        "followStatus": "inactive",
      };
    },
    async getRealEntity() {
      if (!this.entityId) {
        if (Object.keys(useGeneralStore().userData).length > 0) {
          return {
            bio: useGeneralStore().userBio,
            username: useGeneralStore().username,
            avatarUrl: useGeneralStore().userAvatar,
          };
        }
      }
      const response = await $axios.get(`/user/${this.entityId}/profile`);
      return response.data;
    },
  },
};
